import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import Error from "./Error";

export default function Loading() {
  let [showError, setShowError] = useState(false);

  setTimeout(() => {
    setShowError(true);
  }, 5000);

  if (showError) {
    return <Error />;
  } else {
    return (
      <div className="text-center">
        <Spinner className="loading-page" animation="border" role="status">
          <span className="sr-only">Loading...</span>
        </Spinner>
      </div>
    );
  }
}
